var TableMetaData = /** @class */ (function () {
    function TableMetaData() {
    }
    return TableMetaData;
}());
export { TableMetaData };
